import { httpRequest } from '~/adapters/httpRequest';
import { surveyTypesFrom } from '../transformers/survey_type.transformer';

const fetchCompanySurveyTypes = async ({ companyId, lang }: { companyId: number; lang: string }) => {
  try {
    const data = await httpRequest<any>(`/survey-types?companyId=${companyId}&lang=${lang}`);

    if (data.error) return Promise.reject(data.error);
    if (data.errors) return Promise.reject(data.errors[0]);

    const surveyTypeList = surveyTypesFrom(data?.payload?.surveyTypes);
    return surveyTypeList;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const surveyTypesQueries = {
  fetchCompanySurveyTypes,
};
